import {createContext, useState, useEffect} from 'react';
import axios from 'axios';
import { db } from "./Db";

export const UserContext = createContext();

export const Axios = axios.create({
    baseURL: 'php-aplikacja/',
});

export const UserContextProvider = ({children}) => {

    // Blokada wyświetlania pozycji pionowej w przypadku uruchomienia w trybie pełnoekranowym

    const [fullScreen, setFullScreen] = useState(false);

    useEffect(() => {

        const fullscreen = window.matchMedia('(display-mode: fullscreen)').matches || window.navigator.fullscreen;

        if(fullscreen){

            setFullScreen(true);

        }

    }, []);

    useEffect(() => {

        if(fullScreen){

            if(window.screen.orientation && window.screen.orientation.lock){

                window.screen.orientation.lock('portrait').catch(error => {

                    console.error('Failed to lock orientation:', error);

                });

            }

        }

    }, [fullScreen]);

    const [theUser, setUser] = useState(null);

    // Kod identyfikacyjny użytkownika

    useEffect(() => {

        let code = localStorage.getItem("code");

        if(!code){

            generateCode();

        }

        function generateCode(){

            const letters = 'ABCDEFGHIJKLMNOPRSTUWXYZ';

            const number = '0123456789';

            let code = '';

            for(let i = 1; i <= 10; i++){

                if(i <= 3){

                    let random = Math.floor(Math.random() * (23 - 0) + 0);

                    code = code + letters.charAt(random);

                } else {

                    let random = Math.floor(Math.random() * (9 - 0) + 0);

                    code = code + number.charAt(random);

                }

            }

            localStorage.setItem("code", code);

        }

    }, []);

    // Kryptografia

    async function textToArrayBuffer(text){

        const encoder = new TextEncoder();

        return encoder.encode(text);

    }

    function arrayBufferToBase64(buffer){

        return btoa(String.fromCharCode(...new Uint8Array(buffer)));

    }

    function base64ToArrayBuffer(base64){

        const binaryString = atob(base64);

        const bytes = new Uint8Array(binaryString.length);

        for (let i = 0; i < binaryString.length; i++){

            bytes[i] = binaryString.charCodeAt(i);

        }

        return bytes.buffer;

    }

    async function generateKey(dateString){

        const encoder = new TextEncoder();

        const secret = "my_constant_secret";

        const dateKeyMaterial = await crypto.subtle.digest("SHA-256", encoder.encode(dateString + secret));

        return crypto.subtle.importKey(
            "raw",
            dateKeyMaterial,
            { name: "AES-GCM" },
            false,
            ["encrypt", "decrypt"]
        );

    }

    async function encryptString(plainText){

        const date = new Date().toISOString().split('T')[0];

        const key = await generateKey(date);

        const iv = crypto.getRandomValues(new Uint8Array(12));

        const encodedText = await textToArrayBuffer(plainText);

        const encryptedBuffer = await crypto.subtle.encrypt(
            { name: "AES-GCM", iv },
            key,
            encodedText
        );

        return JSON.stringify({
            iv: arrayBufferToBase64(iv),
            data: arrayBufferToBase64(encryptedBuffer),
            date
        });

    }

    async function decryptString(encryptedText){

        if(encryptedText){

            const { iv, data, date } = JSON.parse(encryptedText); 

            if(!date){

                throw new Error("Missing encryption date in data");

            }

            const key = await generateKey(date);

            const decryptedBuffer = await crypto.subtle.decrypt(
                { name: "AES-GCM", iv: base64ToArrayBuffer(iv) },
                key,
                base64ToArrayBuffer(data)
            );

            return new TextDecoder().decode(decryptedBuffer);

        } else {

            return "";

        }

    }

    const encrypt = async (data)=>{

        const encrypted_username = data.username ? await encryptString(data.username) : "";

        const encrypted_user_id = data.user_id ? await encryptString(data.user_id) : "";

        const encrypted_role = data.role ? await encryptString(data.role) : "";

        const encrypted_token = data.token ? await encryptString(data.token) : "";

        const encrypted_code = data.code ? await encryptString(data.code) : "";

        const encrypted_phone_number = data.phone_number ? await encryptString(data.phone_number) : ""; 

        const obj = {username: encrypted_username, user_id: encrypted_user_id, role: encrypted_role, token: encrypted_token, phone_number: encrypted_phone_number, code: encrypted_code}

        return obj;

    }

    const decrypt = async (data) => {

        const decrypted_username = data.username ? await decryptString(data.usernamey) : "";

        const decrypted_user_id = data.user_id ? await decryptString(data.user_id) : "";

        const decrypted_role = data.role ? await decryptString(data.role) : "";

        const decrypted_token = data.token ? await decryptString(data.token) : ""; 

        const decrypted_phone_number = data.phone_number ? await decryptString(data.phone_number) : ""; 

        const decrypted_code = data.code ? await decryptString(data.code) : "";

        const obj = {username: decrypted_username, user_id: decrypted_user_id, role: decrypted_role, token: decrypted_token, phone_number: decrypted_phone_number, code: decrypted_code}

        return obj;

    }

    // Logowanie

    const loginUser = async (formData) => {

        try {

            const {data} = await Axios.post('login.php', {formData});

            if(data.token){

                let user_code = localStorage.getItem("code");

                const code = user_code + "-" + window.navigator.hardwareConcurrency + "-" + window.navigator.maxTouchPoints;

                data.code = code;

                if(userDB.length === 0){

                    createUser(data);

                } else {

                    updateUser(data);

                }

                return data;

            }

            return {message: data.message};

        } catch(err){

            return {success:0, message:'Błąd serwera!'};

        }

    }

    // Wpisywanie użytkownika do lokalnej bazy danych

    const createUser = async (data)=>{

        const encrypted = await encrypt(data);

        await db.user.put({index: 1, username: encrypted.username, user_id: encrypted.user_id, token: encrypted.token, role: encrypted.role, code: encrypted.code});

        setUserDB([{username: encrypted.username, user_id: encrypted.user_id, role: encrypted.role, token: encrypted.token, code: encrypted.code}]);

    }

    // Aktualizacja wpisu użytkownika do lokalnej bazy danych

    const updateUser = async (data)=>{

        const encrypted = await encrypt(data);

        await db.user.update(1, {username: encrypted.username, user_id: encrypted.user_id, token: encrypted.token, role: encrypted.role, code: encrypted.code});

        setUserDB([{username: encrypted.username, user_id: encrypted.user_id, role: encrypted.role, token: encrypted.token, code: encrypted.code}]);

    }

    // Pobieranie użytkownika z lokalnej bazy danych

    const [userDB, setUserDB] = useState([]);

    useEffect(() => {

        db.user.toArray().then(function(result){

            if(result.length > 0){

                setUserDB(result);

            } else {

                setUser({username: '', user_id: '', role: 'none'});

            }

        });

    },[]);

    // Sprawdzanie użytkownika wpisanego do lokalnej bazy danych

    useEffect(() => {

        if(userDB.length > 0){

            const data = userDB[0];

            Axios.options('getUser.php', { timeout: 1500 }).then(function(){

                logOnline(data);

            }).catch((error) => {

                console.log(error);

                setUser({username: '', user_id: '', role: 'none'});

            });

        }

        const logOnline = async (data) => {

            const loginMethod = process.env.REACT_APP_LOGIN_METHOD;

            const decrypted_data = await decrypt(data);

            let stored_code = localStorage.getItem("code");

            const current_code = stored_code + "-" + window.navigator.hardwareConcurrency + "-" + window.navigator.maxTouchPoints;

            if(decrypted_data.code === current_code){

                const loginToken = decrypted_data.token;

                Axios.defaults.headers.common['Authorization'] = 'Bearer '+loginToken;

                Axios.defaults.headers.common['Method'] = loginMethod;

                if(loginToken){

                    const {data} = await Axios.get('getUser.php');

                    if(data.success && data.user){

                        let userData = data.user[0];

                        let role = userData.role ? userData.role : "user";

                        setUser({username: userData.username, user_id: userData.user_id, role: role});

                        return;

                    } else if(data.success === 0 && data.message === "User not found"){

                        setUser({username: '', user_id: '', role: 'none'});

                    } else {

                        setUser({username: '', user_id: '', role: 'none'});

                    }

                } else {

                    setUser({username: '', user_id: '', role: 'none'});

                }

            } else {

                setUser({username: '', user_id: '', role: 'none'});

            }

        }
        // eslint-disable-next-line
    },[userDB]);

    // Weryfikacja numeru telefonu

    const sendOTP = async (formData, resend) => {

        try {

            const {data} = await Axios.post('login.php', {formData, resend});

            if(data.success){

                return data;

            }

            if(data.message){

                return data;

            }

            return {message: 'Wystąpił nieznany błąd. Spróbuj ponownie później.'};

        } catch(err) {

            return {message: 'Wystąpił nieznany błąd. Spróbuj ponownie później.'};

        }

    }

    const verifyOTPCode = async (formData) => {

        try {

            const {data} = await Axios.post('login.php', {formData});

            if(data.success && data.token){

                let user_code = localStorage.getItem("code");

                const code = user_code + "-" + window.navigator.hardwareConcurrency + "-" + window.navigator.maxTouchPoints;

                data.code = code;

                if(userDB.length === 0){

                    createUser(data);    

                } else {

                    updateUser(data);

                }

                return data;

            }

            if(data.message){

                return data;

            }

            return {message: 'Wystąpił nieznany błąd. Spróbuj ponownie później.'};

        } catch(err) {

            return {message: 'Wystąpił nieznany błąd. Spróbuj ponownie później.'};

        }

    }

    // Wylogowanie

    const logout = () => {
        db.user.clear();
        setUser(null);
        window.location.reload(true);
    }

    return (
        <UserContext.Provider value={{loginUser, sendOTP, verifyOTPCode, user:theUser, logout}}>
            {children}
        </UserContext.Provider>
    );

}

export default UserContextProvider;